var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activityCenter" }, [
    _c("div", { staticClass: "activity_header" }, [
      _c("div", [
        _c("i", {
          staticClass: "iconfont icon-xiangyou",
          class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.goBack.apply(null, arguments)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("i", {
          staticClass: "copy iconfont icon-fenxiang",
          class: [_vm.isDirection ? "mirrorRotateLevel" : ""],
          attrs: { "data-clipboard-text": _vm.url },
          on: { click: _vm.handleCopy }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "main_header" }, [
        _c(
          "svg",
          {
            staticClass: "icon",
            attrs: { slot: "image", "aria-hidden": "true" },
            slot: "image"
          },
          [_c("use", { attrs: { "xlink:href": "#icon-renwuzhongxin" } })]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.$t("300358")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main_body" }, [
        _c("div", { staticClass: "horse_loop" }, [
          _c(
            "div",
            [
              _vm.joinUserList.length
                ? _c("horse-lamps", { attrs: { speed: "50" } }, [
                    _c(
                      "div",
                      { staticClass: "trotting-horse-lamp2 ul50" },
                      _vm._l(_vm.joinUserList, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "userHorseLoop" },
                          [
                            item.type === 1
                              ? _c("p", { staticClass: "bold" }, [
                                  _c("img", {
                                    class: [
                                      _vm.isDirection ? "mirrorRotateLevel" : ""
                                    ],
                                    attrs: {
                                      src: require("../../../static/images/coin.png")
                                    }
                                  }),
                                  _c("span", [_vm._v(_vm._s(item.notice))])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.type === 2
                              ? _c("p", { staticClass: "winnerMsg bold" }, [
                                  _c("span", { staticClass: "bold" }),
                                  _c("img", {
                                    class: [
                                      _vm.isDirection ? "mirrorRotateLevel" : ""
                                    ],
                                    attrs: {
                                      src: require("../../../static/images/coin.png")
                                    }
                                  }),
                                  _c("span", { staticClass: "content" }, [
                                    _vm._v(
                                      _vm._s(item.eventName) +
                                        " " +
                                        _vm._s(
                                          _vm.$t("300357", {
                                            user: item.awardeeName,
                                            shop: item.awardGoods
                                          })
                                        )
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "activity_list" },
          [
            _c(
              "van-skeleton",
              {
                staticClass: "productListSkeleton",
                attrs: { row: 1, loading: _vm.loading1 }
              },
              [
                _c("div", {
                  directives: [{ name: "masonry", rawName: "v-masonry" }]
                })
              ]
            ),
            _vm._v(" "),
            _vm.list.length > 0
              ? _c(
                  "van-list",
                  {
                    attrs: {
                      offset: "50",
                      finished: _vm.finished,
                      "loading-text": " ",
                      "finished-text": " "
                    },
                    on: { load: _vm.onLoad },
                    model: {
                      value: _vm.loading,
                      callback: function($$v) {
                        _vm.loading = $$v
                      },
                      expression: "loading"
                    }
                  },
                  _vm._l(_vm.list, function(item, index) {
                    return _c("van-cell", { key: item.id }, [
                      _c("div", { staticClass: "activity_item" }, [
                        _c("div", { staticClass: "image" }, [
                          item.eventState == 2
                            ? _c(
                                "span",
                                { staticClass: "activity_state beInProgress" },
                                [_vm._v(_vm._s(_vm.$t("300359")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.eventState == 1
                            ? _c(
                                "span",
                                {
                                  staticClass: "activity_state isAbouttToBegin"
                                },
                                [_vm._v(_vm._s(_vm.$t("300360")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.eventState == 3
                            ? _c(
                                "span",
                                { staticClass: "activity_state hasEnded" },
                                [_vm._v(_vm._s(_vm.$t("300361")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", { attrs: { src: item.img, alt: "" } }),
                          _vm._v(" "),
                          item.eventAwards.length
                            ? _c(
                                "div",
                                { staticClass: "prizeUser bold" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("300364")) + ":")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "van-swipe",
                                    {
                                      staticClass: "notice-swipe",
                                      attrs: {
                                        vertical: "",
                                        touchable: false,
                                        autoplay: 1500,
                                        "show-indicators": false
                                      }
                                    },
                                    _vm._l(item.eventAwards, function(
                                      items,
                                      index
                                    ) {
                                      return _c(
                                        "van-swipe-item",
                                        { key: index },
                                        [
                                          _c("img", {
                                            class: {
                                              mirrorRotateLevel: _vm.isDirection
                                            },
                                            attrs: {
                                              src: require("../../../static/images/coin.png"),
                                              alt: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(items.eventName) +
                                                _vm._s(
                                                  _vm.$t("300357", {
                                                    user: items.awardeeName,
                                                    shop: items.awardGoods
                                                  })
                                                )
                                            )
                                          ])
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !item.eventAwards.length && item.eventState == 3
                            ? _c(
                                "div",
                                { staticClass: "willBeAnnouncedSoon bold" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("300365")) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "activity_describe" },
                          [
                            _c("div", { staticClass: "activity_title bold" }, [
                              _vm._v(_vm._s(item.eventName))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "line" }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "activity_text",
                              domProps: {
                                innerHTML: _vm._s(item.awardIntroduction)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "date_time" }, [
                              _vm._v(
                                _vm._s(_vm.getTime(item.startTime)) +
                                  " - " +
                                  _vm._s(_vm.getTime(item.endTime))
                              )
                            ]),
                            _vm._v(" "),
                            item.eventState == 2
                              ? _c(
                                  "van-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.toActivity(item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("300362")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.eventState == 3
                              ? _c("van-button", { attrs: { disabled: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("300361")))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.eventState == 1
                              ? _c("van-button", { attrs: { disabled: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("300360")))
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.list.length === 0
              ? _c(
                  "van-skeleton",
                  {
                    staticClass: "productListSkeleton",
                    attrs: { row: 1, loading: _vm.loading1 }
                  },
                  [
                    _c("div", {
                      directives: [{ name: "masonry", rawName: "v-masonry" }]
                    })
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0975b330", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0975b330","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/activityCenter/index.vue
// module id = KKG5
// module chunks = 0